import { createFileRoute, redirect } from '@tanstack/react-router';
import { getStrictCurrentEnterpriseId } from '@mews-commander/core';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/ConnectMewsBI')({
    beforeLoad: () => {
        const currentEnterpriseId = getStrictCurrentEnterpriseId();

        throw redirect({
            to: '/$currentEnterpriseId/EnterpriseIntegration/Marketplace',
            params: { currentEnterpriseId },
            search: {
                OwnerId: currentEnterpriseId,
                CategoryId: 'subscriptions',
                ApplicationId: 'MewsBiIntegration',
            },
        });
    },
    staticData: {
        owner: MewsTeam.Analytics,
        type: RouteType.Redirect,
    },
});
